import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ICommonProps } from '../../types/propTypes/propTypes';
import { Common } from '../../utils/constants';
import { Can } from '../../ability';
import DriverSubscriptionsGrid from './DriverSubscriptionsGrid';
import { IDriverSubscriptionsState } from '../../types/stateTypes';
import { companyNameReplace } from '../../utils';

class DriverSubscriptions extends Component<ICommonProps & WithTranslation, IDriverSubscriptionsState> {
    constructor(props) {
        super(props);
        this.state = {
            filterState: {
                rowsPerPage: 10,
                currentPage: 1,
                sortColumn: 'start_date',
                sortOrder: 'desc',
                offset: 0,
            },
        };
    }
    updateFilterState = (data, callBack: Function | null = null) => {
        this.setState({ ...this.state, filterState: { ...this.state.filterState, ...data } }, () => {
            if (callBack) {
                callBack();
            }
        });
    };
    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('driverSubscriptions.title'))}</title>
                </Helmet>
                <Can I={Common.Actions.MANAGE_PREMIUM_SUBSCRIPTIONS} a={Common.Modules.DRIVERS.ACCOUNTS}>
                    <DriverSubscriptionsGrid
                        {...this.props}
                        t={this.props.t}
                        updateFilterState={this.updateFilterState}
                        filterState={this.state.filterState}
                    />
                </Can>
            </>
        );
    }
}

export default withTranslation()(DriverSubscriptions);
